import { m } from "framer-motion";
// @mui
import { Box } from "@mui/material";
// framer
import { varContainer } from "./variants";
// types
import type { FC, PropsWithChildren } from "react";

// ----------------------------------------------------------------------

interface MotionContainerProps {
  action?: boolean;
  animate?: boolean;
}

export const MotionContainer: FC<PropsWithChildren<MotionContainerProps>> = (
  props,
) => {
  const { animate, action = false, children, ...other } = props;
  if (action) {
    return (
      <Box
        component={m.div}
        initial={false}
        animate={animate ? "animate" : "exit"}
        variants={varContainer()}
        {...other}
      >
        {children}
      </Box>
    );
  }

  return (
    <Box
      component={m.div}
      initial="initial"
      animate="animate"
      exit="exit"
      variants={varContainer()}
      {...other}
    >
      {children}
    </Box>
  );
};
